export const RenderPosition = {
  BEFOREBEGIN: 'beforebegin',
  AFTERBEGIN: 'afterbegin',
  BEFOREEND: 'beforeend',
  AFTEREND: 'afterend'
}

export const createElement = (template) => {
  const newElement = document.createElement('div')
  newElement.innerHTML = template

  return newElement.firstChild
}

export const render = (container, component, place = RenderPosition.BEFOREEND) => {
  switch (place) {
    case RenderPosition.BEFOREBEGIN:
      container.insertAdjacentElement(RenderPosition.BEFOREBEGIN, component)
      break
    case RenderPosition.AFTERBEGIN:
      container.prepend(component)
      break
    case RenderPosition.BEFOREEND:
      container.append(component)
      break
    case RenderPosition.AFTEREND:
      container.insertAdjacentElement(RenderPosition.AFTEREND, component)
      break
  }
}
